import React, { useState, useRef } from "react"
import styled from "styled-components"
import Plus from "./Plus"

function Accordion({ className, ...props }) {
  const [setActive, setActiveState] = useState("");
  const [setHeight, setHeightState] = useState("0px");
  const [setRotate, setRotateState] = useState("accordion__icon");

  const content = useRef(null);

  function toggleAccordion() {
    setActiveState(setActive === "" ? "active" : "");
    setHeightState(
      setActive === "active" ? "0px" : `${content.current.scrollHeight}px`
    );
    setRotateState(
      setActive === "active" ? "accordion__icon" : "accordion__icon rotate"
    );
  }

  return (
    <div className={className}>
      <button className={`accordion ${setActive}`} onClick={toggleAccordion}>
        <p className="accordion__title">{props.title}</p>
        <Plus className={`${setRotate}`} width={20} fill={"#000000"} />
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="accordion__content"
      >
        <div
          className="accordion__text"
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
      </div>
    </div>
  );
}

const StyledAccordion = styled(Accordion)`
  /* Style the accordion section */
  display: flex;
  flex-direction: column;

  /* Style the buttons that are used to open and close the accordion panel */
  .accordion {
    background-color: transparent;
    cursor: pointer;
    padding: 20px 0 0;
    display: flex;
    align-items: center;
    border: none;
    outline: none;
    transition: all 0.35s ease;
    -webkit-tap-highlight-color: transparent;
  }

  /* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
  .accordion:hover,
  .active {
    color: #5656EA;
  }

  /* Style the accordion content title */
  .accordion__title {
    font-weight: 600;
    font-size: 20px;
    text-align: left;
    padding: 0 20px 0 0;
    white-space: pre-line; // Multiline
    margin: 8px 0;
  }

  /* Style the accordion chevron icon */
  .accordion__icon {
    min-width: 20px;
    margin-left: auto;
    transition: transform 0.35s ease;
  }

  /* Style to rotate icon when state is active */
  .rotate {
    transform: rotate(45deg);
    
    & path {
      fill: #5656EA;
      transition: all .35s ease-Out;
    }
  }

  /* Style the accordion content panel. Note: hidden by default */
  .accordion__content {
    overflow: auto;
    transition: max-height 0.6s ease;
  }

  /* Style the accordion content text */
  .accordion__text {
    font-weight: 400;
    font-size: 16px;
    padding: 0 20px 0 0;
    white-space: pre-line; // Multiline
  }
`

export default StyledAccordion;
